<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
            [request]="getRequest"
            [cols]="cols"
            [filtering]="filtering"
            [globalConditionalStyle]="globalConditionalStyle"
            [globalVisualTransform]="globalVisualTransform"
            [showExportCsv]="showCostesTareasFertiCsv"
            (emitSearchText)="updateFooter()">

            <ng-template #header let-data>
                <div 
                    style="width: 100%; margin-right: 15px" 
                    class="d-flex justify-content-center align-items-center" 
                    *ngIf="appName === 'detorres'">
                    <div style="margin-left: 10px; margin-right: 10px">
                        <div style="font-size: 0.7em" class="btn-group">
                            <button 
                                type="button" 
                                class="btn btn-info" 
                                style="padding: 5px; font-size: .8rem; border: none; background-color: #16A2B7; color: white; width: 10rem;"
                                (click)="generateProductsReport()">Informe Productos</button>
                        </div>
                    </div>
                </div>
            </ng-template>
        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center"
                   style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td>
                <app-action-buttons 
                    [hideEdit]="true" 
                    [hideDelete]="true"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>

        <ng-template #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="(['apellidos'].includes(col.field))">
                TOTAL:
            </div>
            <div style="font-size: 0.75em; text-align: right; font-weight: bold"
                 *ngIf="(['resultado'].includes(col.field))">
                {{moneyFormat(col.footer)}} €
            </div>
        </ng-template>

    </app-common-list-table>
</div>

<p-dialog
        *ngIf="canShow['info']"
        header="Detalle del registro"
        [(visible)]="canShow['info']"
        (onShow)="scrollToTop()">

    <div style="width: 80vw !important">
        <app-form-builder
                [fields]="formFields"
                [distributionColumns]="4"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
       
        
            <div class="d-flex justify-content-center" style="margin-top: 40px">
                <button class="btn btn-dark mx-2" (click)="hide('info')">Cerrar</button>
            </div>
    </div>
    <br>

</p-dialog>

<p-dialog 
    *ngIf="canShow['generate']"
    header="Generar archivo" 
    [(visible)]="canShow['generate']" 
    (onShow)="scrollToTop()"
>

    <div  [ngStyle]="{'width.vw': '50'}" style="min-height: 40vw !important;">
        <app-form-builder
            [model]="generar"
            [distributionColumns]="2"
            [fields]="generarFields">
        </app-form-builder>

    <br>
    <div class="d-flex justify-content-center">
        <button class="btn btn-dark mx-2" (click)="hide('generate')">Cerrar</button>

        <a class="d-flex justify-content-center mx-2" >
            <button class="btn btn-primary" (click)="generateProductsReport()">Generar</button>
        </a>

    </div>
    <br>
    </div>
</p-dialog>
